/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_Typical_BodyInputs */

const en_landing_drift_typical_body = /** @type {(inputs: Landing_Drift_Typical_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most image models re-render the whole frame on every edit. Small shifts in colour, texture and position pile up, and by the fifth pass the picture no longer looks like yours.`)
};

const zh_landing_drift_typical_body = /** @type {(inputs: Landing_Drift_Typical_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多数图像模型每次编辑都会重绘整张画面。颜色、纹理和位置的细微偏移不断累积，改到第五次，画面已面目全非。`)
};

/**
* | output |
* | --- |
* | "Most image models re-render the whole frame on every edit. Small shifts in colour, texture and position pile up, and by the fifth pass the picture no longer ..." |
*
* @param {Landing_Drift_Typical_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_typical_body = /** @type {((inputs?: Landing_Drift_Typical_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_Typical_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_typical_body(inputs)
	return zh_landing_drift_typical_body(inputs)
});
export { landing_drift_typical_body as "landing.drift.typical_body" }